import { connect } from "react-redux";
import { PageLibraryReadingList } from "senac-components";
import { commonSlice, contentSlice, userSlice } from "../store/reducers";
import { RootState, AppDispatch, useAppDispatch } from "../store";
import { Wrapper, WrapperDispatchProps, WrapperStateProps } from "./Wrapper";
import {
  ContentFilters,
  ContentGroup,
  ContentHeaderOptionItem,
  MenuOptions,
  PageLibraryHeaderOptionItem,
  ReadingListItem,
} from "senac-components/dist/pages/Mobile/PageInterfaces";
import {
  PageLibraryReadingListDispach,
  PageLibraryReadingListState,
} from "senac-components/dist/pages/Mobile/PageLibraryReadingList";
import {
  PageLibraryReadingListProps,
  PageLibraryReadingListWeb,
  PageLibraryReadingListDispach as PageLibraryReadingListDispachWeb,
} from "senac-components/dist/pages/Web/PageLibraryReadingList";
import {
  FavoritesInternalTag,
  insertTagShared,
  loadTag,
  removeActiveTag,
  searchAndSubscribeTag,
  shareCode,
  updateActiveTag,
  userDataSlice,
} from "../store/reducers/userDataSlice";
import { Content } from "senac-components/dist/pages/Mobile/PageInterfaces";
import { ReadingListWeb } from "./RadingListWeb";
import Sdk from "api.digitalpages.module.sdk.api";
import { filterContent } from "../store/reducers/common";
import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";

const getCollectionList = (state: RootState) => {
  const userState = state.userDataState;

  var data = [...userState.userData, ...userState.userDataShared].filter(
    (p) =>
      p.tags &&
      p.tags.length > 0 &&
      p.name != FavoritesInternalTag &&
      p.targetType == "ManagedContent" &&
      p.contextType == "ManagedContent"
  );
  var uniqueTags = [...userState.tags, ...userState.sharedTags].filter(
    (p) => p.name != FavoritesInternalTag
  );
  var contentsMap: any = {};

  for (var userData of data) {
    for (var tag of userData.tags ?? []) {
      var list = contentsMap[tag.uid];

      if (!list) {
        list = [];
        contentsMap[tag.uid] = list;
      }

      var contentData = state.contentState.allContents.find(
        (p) => p.uid == userData.contextUid
      );
      if (contentData) list.push(contentData);
    }
  }

  var contents: ContentGroup[] = uniqueTags.map((tag) => {
    var contentGroup: ContentGroup = {
      uid: tag.uid,
      title: tag.name,
      editable: true,
      books: contentsMap[tag.uid],
    };
    return contentGroup;
  });

  return contents;
};

const getContetsFromTag = (state: RootState, tagUid?: string) => {
  var allContent = state.contentState.allContents;
  
  const userDataState = state.userDataState;
  var tag = [...userDataState.tags, ...userDataState.sharedTags].find(
    (t) => t.uid === userDataState.activeTagUid
  );
  var data = [
    ...userDataState.userData,
    ...userDataState.userDataShared,
  ].filter(
    (p) =>
      p.tags &&
      p.tags.length > 0 &&
      p.targetType == "ManagedContent" &&
      p.contextType == "ManagedContent"
  );
  var uniqueTags = data
    .map((p) => p.tags ?? [])
    .reduce(
      (p, c) => [...new Map([...c, ...p].map((p) => [p.uid, p])).values()],
      []
    )
    .filter((p) => p.uid == tag?.uid || p.uid === tagUid);
  var contentsUids = data
    .filter(
      (p) =>
        p.tags &&
        p.tags.filter((t) => uniqueTags.find((ut) => ut.uid == t.uid)).length >
          0
    )
    .map((p) => p.contextUid);

  var contents = contentsUids.map((p) =>
    allContent.find((c) => c.uid == p)
  ) as Content[];

  return contents;
};

const mapState = (state: RootState, props: any) => {
  const userDataState = state.userDataState;
  var allContent = state.contentState.allContents;
  var activeContent = state.contentState.activeContentReference;
  var tag = [...userDataState.tags, ...userDataState.sharedTags].find(
    (t) => t.uid === userDataState.activeTagUid
  );
  var contents = getContetsFromTag(state);
  var suggestGroup: ContentGroup | undefined = undefined;

  if (state.contentState.suggestedContent) {
    suggestGroup = {
      uid: "sugges",
      title: "Sugestões para sua lista",
      books: allContent.filter((p) =>
        state.contentState.suggestedContent?.find((s) => s == p.uid)
      ),
    };
  }

  const list = getCollectionList(state);
  const name = `Nova lista ${list.length + 1}`;

  const getContentsFromTagUid = async (code: string) => {
    var url = `cms/v1.1/user/data/shared/available?code_share=${code}`;
    return await Sdk.Api.dynamic.bridge(url, null, "GET")
    .then(response => response.result.map((item : { context_uid: string }) => item.context_uid))
    .catch(err => err);
  }
  const onSearch = async (code: string) => {
    var url = `cms/v1.1/user/data/tags/shared/available?code_share=${code}`;
    const contents = await getContentsFromTagUid(code);
    return await Sdk.Api.dynamic
      .bridge(url, null, "GET")
      .then((response) => {
        if (response.result.length) {
          const [tag] = response.result;
          return {
            ...tag,
            contents: allContent.filter(content => contents.includes(content.uid))
          }
        }
      })
      .catch(err => err);
  };
  let result: PageLibraryReadingListState &
    Partial<PageLibraryReadingListProps> & { importingCode?: string } = {
    suggestContents: suggestGroup,
    activeBook: activeContent,
    listName: name,
    onSearchListShare: onSearch,
    importingCode: state.userState.codeReadingList
  };

  if (tag) {
    result.detail = { ...tag, contents: contents };
    result.processing = false;
  }

  return result;
};

const commomDispatch = (dispatch: AppDispatch, props: any) => {
  const result: PageLibraryReadingListDispach = {
    onSelectedHeaderBack: () => dispatch(commonSlice.actions.backPage()),
    onSelectedHeaderMenuOption: (option: PageLibraryHeaderOptionItem) =>
      dispatch(commonSlice.actions.goToLibraryOption(option)),
    onSelectedNavigationPageOption: (option: MenuOptions) =>
      dispatch(commonSlice.actions.goToPage(option)),
    onClickDeleteList: () => dispatch(removeActiveTag()),
    onClickShareCode: (code: string) => dispatch(shareCode(code)),
    onChangeList: (list: ReadingListItem) => dispatch(updateActiveTag(list)),
    onClickSearchShare: (uid: string) => dispatch(searchAndSubscribeTag(uid)),
    onChangeFilter: (filter) => {
      if (filter.query === undefined) return;
      dispatch(filterContent({ query: filter.query }));
    },
  };

  return result;
};

// const getList = (code: string) => {

// }
const webDispatch = (dispatch: AppDispatch, props: any) => {
  const commom = commomDispatch(dispatch, props);
  const result: PageLibraryReadingListDispach &
    PageLibraryReadingListDispachWeb = {
    ...commom,
  };
  return result;
};

const WPageLibraryReadingList = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (code) {
      dispatch(userSlice.actions.setImportReadingList(code));
    }
  }, []);
  
  const Mobile = connect(mapState, commomDispatch)(PageLibraryReadingList);
  const Web = connect(mapState, webDispatch)(PageLibraryReadingListWeb);
  if (window.innerWidth < 1024) return <Mobile />;
  return <Web />;
};

export { WPageLibraryReadingList };
